var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "url(#paint0_linear_5169_8253)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5169_8253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 26C40.392 26 44.878 29.88 45.819 35C44.879 40.12 40.392 44 35 44C29.608 44 25.122 40.12 24.181 35C25.121 29.88 29.608 26 35 26ZM35 42C37.0395 41.9996 39.0184 41.3068 40.6129 40.0352C42.2074 38.7635 43.3229 36.9883 43.777 35C43.3213 33.0133 42.205 31.24 40.6107 29.97C39.0163 28.7 37.0383 28.0085 35 28.0085C32.9617 28.0085 30.9837 28.7 29.3894 29.97C27.7951 31.24 26.6788 33.0133 26.223 35C26.6771 36.9883 27.7927 38.7635 29.3872 40.0352C30.9816 41.3068 32.9606 41.9996 35 42ZM35 39.5C33.8066 39.5 32.662 39.0259 31.8181 38.182C30.9741 37.3381 30.5 36.1935 30.5 35C30.5 33.8065 30.9741 32.6619 31.8181 31.818C32.662 30.9741 33.8066 30.5 35 30.5C36.1935 30.5 37.3381 30.9741 38.182 31.818C39.0259 32.6619 39.5 33.8065 39.5 35C39.5 36.1935 39.0259 37.3381 38.182 38.182C37.3381 39.0259 36.1935 39.5 35 39.5ZM35 37.5C35.6631 37.5 36.299 37.2366 36.7678 36.7678C37.2366 36.2989 37.5 35.663 37.5 35C37.5 34.337 37.2366 33.7011 36.7678 33.2322C36.299 32.7634 35.6631 32.5 35 32.5C34.337 32.5 33.7011 32.7634 33.2323 33.2322C32.7634 33.7011 32.5 34.337 32.5 35C32.5 35.663 32.7634 36.2989 33.2323 36.7678C33.7011 37.2366 34.337 37.5 35 37.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5169_8253",
    x1: 80.5329,
    y1: 19.6874,
    x2: 42.2152,
    y2: 20.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBE5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FC5059"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5169_8253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(23 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.60e76c85c3a8cccca838aa620c91a024.svg";
export { ForwardRef as ReactComponent };